import { z } from 'zod';

export const FeedbackModelSchema = z.object({
  name: z.string().regex(/^[\p{L} -]+$/u).optional(),
  message: z.string().optional(),
  email: z.string().email().optional(),
  location: z.string().regex(/^[A-Za-z0-9$-_.+!*'()/&?=:%]+$/).optional(),
});

export type FeedbackModel = z.infer<typeof FeedbackModelSchema>;
